import React, { useState } from "react";
import "./Mid-Section-Pc.scss";

const MessagingApp = () => {
  const [messageInput, setMessageInput] = useState("");
  const [activeChat, setActiveChat] = useState("Caretaker");

  const [chats, setChats] = useState([
    {
      user: "Caretaker",
      // profilePicture: 'https://example.com/profiles/allan.jpg', // Example profile picture URL
      messages: [
        {
          text: "Hello! How are you?",
          type: "incoming",
          timestamp: "2024-08-24T09:30:00",
        },
        {
          text: "I am fine, thank you!",
          type: "outgoing",
          timestamp: "2024-08-24T09:35:00",
        },
      ],
    },
    {
      user: "Admin",
      profilePicture: "", // No profile picture, will use default blue circle
      messages: [
        {
          text: "Hey, any updates on the project?",
          type: "incoming",
          timestamp: "2024-08-24T10:00:00",
        },
        {
          text: "Yes, I have made some changes to the project plan and updated the timeline accordingly.",
          type: "outgoing",
          timestamp: "2024-08-24T10:05:00",
        },
      ],
    },
    {
      user: "Landlord",
      // profilePicture: 'https://example.com/profiles/daniel.jpg', // Example profile picture URL
      messages: [
        {
          text: "Can we meet tomorrow?",
          type: "incoming",
          timestamp: "2024-08-24T11:00:00",
        },
        {
          text: "Sure, what time?",
          type: "outgoing",
          timestamp: "2024-08-24T11:05:00",
        },
      ],
    },
  ]);

  const handleInputChange = (event) => {
    setMessageInput(event.target.value);
  };

  const handleSendMessage = () => {
    if (messageInput.trim()) {
      const newMessage = {
        text: messageInput,
        type: "outgoing",
        timestamp: new Date().toISOString(),
      };
      const updatedChats = chats.map((chat) =>
        chat.user === activeChat
          ? { ...chat, messages: [...chat.messages, newMessage] }
          : chat
      );
      setChats(updatedChats);
      setMessageInput("");
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString();
  };

  const handleChatSelect = (user) => {
    setActiveChat(user);
  };

  const getLastMessageSnippet = (messages) => {
    if (messages.length === 0) return "";
    const lastMessage = messages[messages.length - 1].text;
    if (lastMessage.length > 20) {
      return lastMessage.substring(0, 20) + "...";
    }
    return lastMessage;
  };

  const getLastMessageTimestamp = (messages) => {
    if (messages.length === 0) return "";
    return formatTimestamp(messages[messages.length - 1].timestamp);
  };

  const currentChat = chats.find((chat) => chat.user === activeChat);

  return (
    <div className="messaging-app-pc">
      <div className="chat-container">
        <aside className="chat-sidebar">
          <div className="chat-list">
            {chats.map((chat, index) => (
              <div
                key={index}
                className={`chat-item ${
                  activeChat === chat.user ? "active" : ""
                }`}
                onClick={() => handleChatSelect(chat.user)}
              >
                <div className="profile-picture">
                  {chat.profilePicture ? (
                    <img src={chat.profilePicture} alt={chat.user} />
                  ) : (
                    <div className="default-profile-picture"></div>
                  )}
                </div>
                <div className="chat-details">
                  <div className="chat-header">
                    <span className="chat-user">{chat.user}</span>
                  </div>

                  <div className="chat-snippet">
                    {getLastMessageSnippet(chat.messages)}
                  </div>
                  <span className="last-message-timestamp">
                    {getLastMessageTimestamp(chat.messages)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </aside>

        <main className="chat-main">
          <div className="chat-messages">
            {currentChat.messages.map((message, index) => {
              const showDateSeparator =
                index === 0 ||
                formatDate(message.timestamp) !==
                  formatDate(currentChat.messages[index - 1].timestamp);
              return (
                <React.Fragment key={index}>
                  {showDateSeparator && (
                    <div className="date-separator">
                      {formatDate(message.timestamp)}
                    </div>
                  )}
                  <div
                    className={`message ${
                      message.type === "incoming" ? "incoming" : "outgoing"
                    }`}
                  >
                    <span className="message-text">{message.text}</span>
                    <span className="timestamp">
                      {formatTimestamp(message.timestamp)}
                    </span>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
          <div className="chat-input-container">
            <input
              type="text"
              className="chat-input"
              placeholder="Type a message..."
              value={messageInput}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
            />
            <button className="send-button" onClick={handleSendMessage}>
              Send
            </button>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MessagingApp;
